var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.286 0.713928H0.713867V39.2861H39.286V0.713928Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5399 10.7496C19.917 10.7496 18.3605 11.3943 17.2129 12.5419C16.0653 13.6895 15.4206 15.246 15.4206 16.869H12.2385V19.9694H15.2982V32.2081H18.4598V19.9694H21.5399V16.8894H18.4598C18.5467 16.1388 18.9064 15.4463 19.4705 14.9436C20.0347 14.4409 20.7639 14.1632 21.5195 14.1632C22.2751 14.1632 23.0044 14.4409 23.5685 14.9436C24.1327 15.4463 24.4924 16.1388 24.5792 16.8894H27.6388C27.6415 16.0858 27.4859 15.2895 27.1808 14.546C26.8758 13.8026 26.4273 13.1265 25.861 12.5564C25.2946 11.9862 24.6215 11.5332 23.8801 11.2232C23.1387 10.9132 22.3435 10.7523 21.5399 10.7496V10.7496Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookShareIcon);
export default __webpack_public_path__ + "static/media/facebook-share-icon.48ae2d8056e916e29c4ed20a9982596d.svg";
export { ForwardRef as ReactComponent };